import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SimpleSliderDirective } from 'src/app/modules/courts-internal/slideshow.directive';
import { LazyReactComponentDirective } from './lazyReactComponent.directive';

@NgModule({
    declarations: [SimpleSliderDirective, LazyReactComponentDirective],
    imports: [CommonModule],
    exports: [CommonModule, SimpleSliderDirective, LazyReactComponentDirective],
})
export class MyDirectivesModule {}
